export default __webpack_public_path__ + "static/media/Group 1673.87b00c5f.svg";